/**
 * The one auth cookie the SPA reads.
 *
 * The server derives every cookie name from `app.cookie_prefix` (ADR-0059); this side spells
 * the result out, because the SPA has no way to ask before it is signed in. The backend's
 * AuthenticationFlowTest pins the same literal names, so a change of prefix fails there
 * before it fails here as a CSRF refusal on every write.
 *
 * Only the CSRF cookie: the access and refresh cookies are HttpOnly and invisible to script,
 * which is the point of them.
 */
export const CSRF_COOKIE = '__Host-frische_csrf'

const CSRF_COOKIE_PATTERN = new RegExp(
  `(?:^|; )${CSRF_COOKIE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`,
)

/** The double-submit value to echo in the `X-CSRF-Token` header; null before sign-in. */
export function readCsrfCookie(): string | null {
  const match = document.cookie.match(CSRF_COOKIE_PATTERN)
  return match ? decodeURIComponent(match[1]) : null
}
